module.exports = __webpack_public_path__ + "a05e5af3d2f7d13b35023685fa358cb1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/dreidel.png
// module id = 2633
// module chunks = 0